// extracted by mini-css-extract-plugin
export default {"modal-body":"ModalBody_modal-body__tZD5v","sidebar":"ModalBody_sidebar__Q3Kty","body":"ModalBody_body__vjDDy"};